import * as i0 from "@angular/core";
export class AppendToBodyModule {
}
AppendToBodyModule.ɵfac = function AppendToBodyModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppendToBodyModule)(); };
AppendToBodyModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppendToBodyModule });
AppendToBodyModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
